import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmMessageModalContext } from '../confirm-message-modal/confirm-message-modal.component';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ModalHelper } from '@services/modal-helper.service';
import { AppState } from '@app/app.service';
import { UserAccountService } from '@ztarmobile/zwp-service-backend-v2';

export type ChangePinData = {
  currentPin: string,
  mdn: string,
  customClass?: string,
}

@Component({
  selector: 'app-change-pin-modal',
  templateUrl: './change-pin-modal.component.html',
  styleUrl: './change-pin-modal.component.scss'
})
export class ChangePinModalComponent implements OnInit {

  public step = 1;
  public currentPinForm: FormGroup;
  public showCurrentError = false;
  public showCurrentPin = false;

  public newPinForm: FormGroup;
  public showNewPin = false;
  public showConfirmPin = false;
  public showMismatchError = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ChangePinData,
    public dialog: MatDialogRef<ConfirmMessageModalContext>,
    private userAccountService: UserAccountService,
    private modalHelper: ModalHelper,
    private appState: AppState
  ) { }

  ngOnInit(): void {
    this.currentPinForm = new FormGroup({
      pin: new FormControl('', [Validators.required])
    });

    this.newPinForm = new FormGroup({
      newPin: new FormControl('', [Validators.required, Validators.minLength(4)]),
      confirmNewPin: new FormControl('', [Validators.required])
    },
      { validators: this.matchValidator('newPin', 'confirmNewPin') }
    );
  }

  matchValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup): ValidationErrors | null => {
      const control = formGroup.get(controlName);
      const matchingControl = formGroup.get(matchingControlName);

      if (!control || !matchingControl) {
        return null; // one of them is missing
      }

      return control.value === matchingControl.value ? null : { mismatch: true };
    };
  }

  public submitCurrentPin(): void {
    this.currentPinForm.markAllAsTouched();
    if (this.currentPinForm.invalid) {
      return;
    }

    if (this.data.currentPin === this.currentPinForm.controls.pin.value) {
      this.step = 2;
    } else {
      this.showCurrentError = true;
    }
  }

  public editAccountPin(): void {
    this.newPinForm.markAllAsTouched();

    if (this.newPinForm.invalid || !this.validatePin()) {
      return;
    }

    this.appState.loading = true;
    this.userAccountService.changeAccountPin(this.data.mdn,this.newPinForm.controls.newPin.value).then(() => {
      this.closeDialog(this.newPinForm.controls.newPin.value);
      this.modalHelper.successModal(
        '',
        'Done',
        'secondary-success-modal no-massage',
        'PIN Number Successfully Updated',
        '',
        'assets/icon/banner-success-icon.svg',
        true,
      )
      this.appState.loading = false;
    }).catch((error) => {
      this.cancel();
      console.warn(error);
      this.modalHelper.failureModal(
        'Your request cannot be processed at this moment. Please try again later.',
        'Got It',
        'secondary-fail-modal',
        'Something Went Wrong!',
        '',
        'assets/icon/circle-error.svg'
      );
      this.appState.loading = false;
    });
  }

  public validatePin(): boolean {
    const pinCode = this.newPinForm.controls?.newPin?.value
    if (pinCode > 0) {
      const sequentialPatternA = '012345678901234567890';
      const sequentialPatternB = '098765432109876543210';
      if (pinCode.length === 4 &&
        sequentialPatternA.indexOf(pinCode) === -1 &&
        sequentialPatternB.indexOf(pinCode) === -1 &&
        !(pinCode[0] === pinCode[1] &&
          pinCode[0] === pinCode[2] &&
          pinCode[0] === pinCode[3])) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }

  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?): void {
    this.beforeClose();
    this.dialog.close(res);
  }

  cancel(): void {
    this.closeDialog(false);
  }
}
